import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Body from '../content/body';
import Sidebar from '../content/sidebar';

const PostDefault = props => {
  const { posts, advertorial, isList } = props;
  const post = get(posts, '[0]', {});

  if (isList) {
    const isSVGimage = post.customFields.header_image_desktop.includes('.svg');
    let listData = post.content.join();

    listData = listData
      .replace(/,<p><\/p>/gm, '')
      .replace(/,<hr>,/gm, '<!-- SPLIT -->')
      .split('<!-- SPLIT -->');

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < listData.length; i++) {
      listData[i] = listData[i]
        .replace(/<\/p>,?/gm, '')
        .replace(/<p>/gm, '<!-- SPLIT -->')
        .split('<!-- SPLIT -->');

      // IMAGE
      const imgUrlData = listData[i][0].match(/src="\S+"/);

      if (imgUrlData === null) {
        return false;
      }

      const imgUrl = imgUrlData[0].replace('src="', '').replace('"', '');
      listData[
        i
      ][0] = `<div class="image" style="background-image: url(${imgUrl})"></div>`;

      // LINK
      if (listData[i][4]) {
        listData[i][4] = listData[i][4]
          .replace(/<a href="/gi, '')
          .replace(/">.+<\/a>/gi, '');
      }
    }

    return (
      <section className={`list-page list-${post.id}`}>
        <header className="header">
          <div className="hero">
            {post.customFields.header_image_desktop && (
              <h1>
                {isSVGimage && (
                  <object
                    type="image/svg+xml"
                    data={post.customFields.header_image_desktop}
                    className={`desktop ${!post.customFields
                      .header_image_mobile && 'no-mobile'}`}
                    aria-label={post.title}
                  />
                )}
                {!isSVGimage && (
                  <img
                    src={post.customFields.header_image_desktop}
                    className="desktop"
                    alt={post.title}
                  />
                )}

                {post.customFields.header_image_mobile &&
                  isSVGimage && (
                    <object
                      type="image/svg+xml"
                      data={post.customFields.header_image_desktop}
                      className="desktop"
                      aria-label={post.title}
                    />
                  )}
                {post.customFields.header_image_mobile &&
                  !isSVGimage && (
                    <img
                      src={post.customFields.header_image_desktop}
                      className="desktop"
                      alt={post.title}
                    />
                  )}
              </h1>
            )}
          </div>

          {post.customFields.list_deck && (
            <h2 className="deck">{post.customFields.list_deck}</h2>
          )}
        </header>

        <div className="post post--default">
          <div className="post__main">
            <Body
              {...props}
              post={post}
              isLongPost={true}
              hasNewsletter={true}
              fullPageAdvertorial={advertorial}
              listData={listData}
            />
          </div>

          <Sidebar
            {...props}
            post={get(posts, '[0]')}
            fullPageAdvertorial={advertorial}
            isLongPost={true}
          />
        </div>
      </section>
    );
  }

  return (
    <div className="post post--default">
      <div className="post__main">
        <Body
          {...props}
          post={post}
          isLongPost={true}
          hasNewsletter={true}
          fullPageAdvertorial={advertorial}
        />
      </div>
      <Sidebar
        {...props}
        post={get(posts, '[0]')}
        fullPageAdvertorial={advertorial}
        isLongPost={true}
      />
    </div>
  );
};

PostDefault.defaultProps = {
  isList: false
};

PostDefault.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  advertorial: PropTypes.bool.isRequired,
  isList: PropTypes.bool
};

export default PostDefault;
